const CYCLE_LENGTH_MS = 24 * 60 * 60 * 1000;

class SaleCountdownController {
  elements = new Set();

  intervalId = null;

  add(element) {
    this.elements.add(element);
    this.updateElement(element, Date.now());

    if (this.intervalId === null) {
      this.intervalId = window.setInterval(() => this.updateAll(), 1000);
    }
  }

  remove(element) {
    this.elements.delete(element);

    if (this.elements.size === 0 && this.intervalId !== null) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  updateAll() {
    const now = Date.now();
    this.elements.forEach((element) => this.updateElement(element, now));
  }

  updateElement(element, now) {
    const reference = Date.parse(element.dataset.cycleStart || '');
    if (!Number.isFinite(reference)) return;

    const elapsed = Math.max(0, now - reference);
    const activeCycle = Math.floor(elapsed / CYCLE_LENGTH_MS);
    const deadline = reference + (activeCycle + 1) * CYCLE_LENGTH_MS;
    const secondsRemaining = Math.max(0, Math.floor((deadline - now) / 1000));
    const values = {
      days: Math.floor(secondsRemaining / 86400),
      hours: Math.floor((secondsRemaining % 86400) / 3600),
      minutes: Math.floor((secondsRemaining % 3600) / 60),
      seconds: secondsRemaining % 60,
    };

    Object.entries(values).forEach(([part, value]) => {
      const target = element.querySelector(`[data-countdown-part="${part}"]`);
      if (target) target.textContent = String(value).padStart(2, '0');
    });

    element.dataset.deadline = new Date(deadline).toISOString();
  }
}

const controller = new SaleCountdownController();

class SaleCountdown extends HTMLElement {
  connectedCallback() {
    controller.add(this);
  }

  disconnectedCallback() {
    controller.remove(this);
  }
}

if (!customElements.get('sale-countdown')) {
  customElements.define('sale-countdown', SaleCountdown);
}
